import { FormEngineInputElementProps } from '@form-engine/element-input/components/input-element';
import { useFormEngineElement } from '@form-engine/core-application/hooks/use-element';
import BsoAttachmentsUploadInput from './attachments-upload-input';
import BsoAttachmentsUploadInputList from './attachments-upload-input-list';

export const apiName = 'BsoAttachmentsElement' as const;

export const defaultCategory = 'Other';

export default Object.assign(
    function BsoAttachmentsElement(props: FormEngineInputElementProps) {
        const { state: element } = useFormEngineElement();
        if (!element || element.type !== apiName)
            throw new Error('tried to render input with invalid definition');
        const { multiple = false, renderAsList = false } = element;

        const ComponentType =
            multiple && renderAsList
                ? BsoAttachmentsUploadInputList
                : BsoAttachmentsUploadInput;

        return <ComponentType {...props} />;
    },
    { apiName, isField: true, enabled: true }
);
